import { Card, Col, DatePicker, Empty, Input, Spin } from 'antd'; // Import Ant Design components
import dayjs from 'dayjs';
import { ManagementItemView } from 'features/management-report/components/subscription-table/subscription-table-view';
import { SubscriptionTopBar } from 'features/management-report/components/top-bar/management-top';
import { useGetManagementReportList } from 'features/management-report/use-cases/get-management';
import { useUserContext } from 'features/users';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { disabledDate } from 'routes/utils';
export const ManagementReportView = () => {
  const { user, menuItem, companyUser } = useUserContext();
  // States for selected Year and Month
  const [searchName, setSearchName] = useState('');
  const [year, setYear] = useState(dayjs().year().toString());
  const [month, setMonth] = useState((dayjs().month() + 1).toString()); // Month is 0-indexed
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const navigate = useNavigate();
  // Use selected Year and Month for pagination and filtering
  const params: any = {
    PageIndex: 1,
    RecordPerPage: 10,
    CompanyId: user?.CompanyId,
    // PeriodId: selectedValue || 3,
    Year: year,
    Month: month,
    Name: searchName,
  };

  const [editSubscriptionModal, setEditSubscriptionModal] = useState(false);
  const [editSubData] = useState('');

  // Fetch data with selected Year and Month
  const { isFetching, data: reportData } = useGetManagementReportList(params);
  const handleDateChange = (date: any) => {
    if (date) {
      // Update to the selected date
      setSelectedDate(date);
      setYear(date.year().toString());
      setMonth((date.month() + 1).toString());
    } else {
      // Reset to the current date when cleared
      const currentDate = dayjs();
      setSelectedDate(currentDate);
      setYear(currentDate.year().toString());
      setMonth((currentDate.month() + 1).toString());
    }
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchName(e.target.value);
  };
  useEffect(() => {
    if (menuItem?.rc[0]?.Url === 'dashboard') {
      navigate('/dashboard');
    }
  }, [menuItem?.rc[0]?.Url, navigate]);
  useEffect(() => {
    if (!companyUser?.rc || companyUser.rc.length === 0) {
      navigate('/no-company'); // Redirect to "not found" route
    }
  }, [companyUser?.rc, navigate]);
  
return (
    <>
      <div className='flex '>
        <SubscriptionTopBar
          setEditSubscriptionModal={setEditSubscriptionModal}
          editSubscriptionModal={editSubscriptionModal}
          editSubData={editSubData}
        />
        <div className='flex gap-2'>
          <Col>
            <Input
              placeholder='Search by Name'
              value={searchName}
              onChange={handleSearchChange}
            />
          </Col>
          <Col>
            <DatePicker
              className='form-control'
              style={{ minWidth: '155px' }}
              picker='month'
              value={selectedDate} // Controlled value
              defaultValue={dayjs()} // Default to current month/year
              onChange={handleDateChange as any}
              disabledDate={disabledDate}
              allowClear={false}
              format='MMMM YYYY' // Display as "Month Name YYYY"
            />
          </Col>
        </div>
      </div>
      {/* Loading state */}
      <Card>
        {isFetching ? (
          <Spin className='spnldrbx' size='large' />
        ) : reportData?.rc?.length === 0 ? (
          <Empty description='No data found' />
        ) : (
          <ManagementItemView
            isRoleListLoading={isFetching}
            dataList={reportData}
          />
        )}
      </Card>

      <Outlet />
    </>
  );
};
